"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    return {
        bordered: { border: "solid 1px" },
        roundedBorder: { borderRadius: "5px !important" },
        flatBorder: { borderRadius: "0 !important" },
        circleBorder: { borderRadius: "50% !important" }
    };
});
//# sourceMappingURL=Border.js.map